import { Grid, Tooltip, Typography } from "@material-ui/core";
import { AiFillQuestionCircle } from "react-icons/ai";
import { useWatch } from "react-hook-form";
import TextInput from "shared/components/input/TextInput";
import InputAnexo from "shared/components/input/InputAnexo";

type ConfigurarCertificadoProps = {
  control: any;
  register: any;
  setValue: any;
  customId?: any;
};

const ConfigurarCertificado = ({
  control,
  register,
  setValue,
  customId = "certificadoDigitalBase64",
}: ConfigurarCertificadoProps) => {
  const nomeCertificadoDigital = useWatch({ control, name: "nomeCertificadoDigital" });

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} style={{ marginBottom: "1rem" }}>
        <Typography variant="body2" style={{ fontWeight: "bold" }}>
          Anexe o certificado A1 e senha
          <Typography variant="body2">Os dados do certificado são únicos para cada condomínio</Typography>
        </Typography>
      </Grid>

      <Grid item md={6} sm={6} xs={6}>
        <InputAnexo
          id={customId}
          name={customId}
          label={
            <>
              Anexar certificado
              <Tooltip
                title="Certificado A1 é um arquivo digital que contém a chave privada e pública do certificado digital."
                placement="right"
              >
                <AiFillQuestionCircle style={{ marginLeft: "0.8rem", fontSize: "0.9rem" }} />
              </Tooltip>
            </>
          }
          accept=".pfx,.p12"
          control={control}
          setValue={setValue}
          placeholder={nomeCertificadoDigital}
        />
      </Grid>
      <Grid item md={6} sm={6} xs={6}>
        <TextInput
          id="senhaCertificado"
          key="senhaCertificadoInput"
          name="senhaCertificadoDigital"
          label="Senha do certificado"
          control={control}
          register={register}
          setValue={setValue}
          isPassword
          usarValidacaoParaFormulario
          placeholder="Informe a senha"
          autoComplete="new-password"
        />
      </Grid>
    </Grid>
  );
};

export default ConfigurarCertificado;
